<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">一件代发</span>
      <button @click="client_code='';show_add=true" class="btn-scan ivu-btn ivu-btn-primary fr ml20">创建导入批次</button>
    </div>
    <!-- <div class="tr mb10">
      <button class="ivu-btn ivu-btn-primary" @click="exportData">下载数据</button>
    </div> -->
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        导入批次号
        <Input class='ml10 mr20 w200' v-model="screen_data.post_batch_no" placeholder="请输入导入批次号" />
        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="search">搜索</button>
      </div>
      <div class="search-item">

      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>


    <Modal v-model="show_add" class-name="vertical-center-modal">
      <div slot="header">创建导入批次</div>
      <div class="p20 tc">
        客户编号： <Input v-model="client_code" class="w200"></Input>
      </div>
      <div slot="footer" class="tc">
        <button class="ivu-btn ivu-btn-white" @click="show_add=false">取消</button>
        <button class="ivu-btn ivu-btn-primary" @click="addBatch">确定</button>
      </div>
    </Modal>

  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        client_code: '',
        show_add: false,
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
      }
    },
    methods: {
      addBatch() {
        if (!this.client_code) {
          this.$Message.info("请输入客户编号");
          return false
        }
        this.$axios.post("/WarehousePost/batch", this.$qs.stringify({
          warehouse_id: this.screen_data.warehouse_id,
          client_code: this.client_code
        })).then(res => {
          if (res.success) {
            this.$Message.success('创建成功');
            this.show_add = false
            this.getList()
          } else {
            this.$Message.error(res.msg);
          }
        })
      },
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.start_date = e + ' 00:00:00'
        } else {
          this.screen_data.start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.end_date = e + ' 23:59:59'
        } else {
          this.screen_data.end_date = ''
        }
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/WarehousePost/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      deletePostBatch(post_batch_no){

        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要删除单号为 ' + post_batch_no + ' 的发货单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            this.$axios.delete("/WarehousePost/batch", {
              params: {
                post_batch_no: post_batch_no
              }
            }).then(res => {
              this.loading = false;
              if (res.success) {
                this.$Message.success(res.msg);
                this.getList();
              }

            })
          },
          onCancel: () => {

          }
        });


      },
      exportPostBatch(post_batch_no) {
        this.$axios.get("/WarehousePost/batch/export/excel", {
          params: {
            post_batch_no: post_batch_no
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '导入批次号',
          key: 'post_batch_no',
          tooltip: true,
          minWidth: 230,
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '姓名',
          key: 'user_name',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '发货单数',
          key: 'total_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '完成数',
          key: 'packed_count',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '创建时间',
          key: 'create_date',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '操作',
          minWidth: 130,
          render: (h, params) => {

            let doms = [];

            doms.push(h('a', {
              on: {
                click: () => {
                  this.$router.push({
                    path: '/tuihuozhijian/one/list',
                    query: {
                      post_batch_no: params.row.post_batch_no,
                      total_count: params.row.total_count
                    }
                  })
                }
              }
            }, '查看详情 '));

            if (params.row.total_count == 0) {
              doms.push(h('a', {
                on: {
                  click: () => {
                    this.deletePostBatch(params.row.post_batch_no);
                  }
                }
              }, ' 删除'));
            }else{
              doms.push(h('a', {
                on: {
                  click: () => {
                    this.exportPostBatch(params.row.post_batch_no);
                  }
                }
              }, ' 导出发货单'));
            }

            return h('div', doms);
          }
        }];
        return arr;
      },

    },
    created() {
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      // this.screen_data.client_code = localStorage.getItem('client_code') || '';
      this.screen_data.biz_type = 2;
      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style scoped>
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/one/batch.vue